import { enableProdMode } from '@angular/core';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Custom string extension
import 'src/app/string-prototypes';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { platformBrowser } from '@angular/platform-browser';

if (environment.production) {
  enableProdMode();
}

platformBrowser().bootstrapModule(AppModule)
  .catch(err => console.log(err));

// PWA Elements for Camera or Toast when not running natively https://capacitorjs.com/docs/web/pwa-elements
defineCustomElements(window);
